const LOGOS = [
  {
    src: "https://s3-portal-2020.conny.de/public/conny/Zeit.webp",
    alt: "DIE ZEIT",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/Spiegel.avif",
    alt: "Der Spiegel",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/FAZ_logo.webp",
    alt: "Frankfurter Allgemeine Zeitung",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/Handelsblatt_logo.webp",
    alt: "Handelsblatt",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/ARD.webp",
    alt: "ARD",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/ZDF.webp",
    alt: "ZDF",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/BerlinerZeitung.webp",
    alt: "Berliner Zeitung",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/Galileo.webp",
    alt: "Galileo",
  },
  {
    src: "https://s3-portal-2020.conny.de/public/conny/Welt_TV_Logo_2016.webp",
    alt: "Welt",
  },
];

export function MediaBannerCard() {
  return (
    <div className="cn">
      <div className="cn-marquee-wrap">
        <div className="cn-marquee-track">
          {[...LOGOS, ...LOGOS].map((logo, i) => (
            <img
              key={i}
              src={logo.src}
              alt={logo.alt}
              className="cn-marquee-logo"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
